module.exports = __webpack_public_path__ + "img/674f348.jpg";